import moment from "moment";

export const Format = (date: string): string => {
    if (date === null) {
        return "";
    }
    return moment(date).format("DD/MM/YYYY").toString();
};
